"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreatorDataActionButtons = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const useUser_1 = require("root/src/client/v2/common/hooks/useUser");
const useCreatorData_1 = require("root/src/client/logic/api/hooks/useCreatorData");
const auditFollowCreator_1 = __importDefault(require("root/src/client/logic/creatorData/thunks/auditFollowCreator"));
const displayModal_1 = __importDefault(require("root/src/client/logic/modal/thunks/displayModal"));
const moduleIds_1 = require("root/src/shared/descriptions/modules/moduleIds");
const react_1 = require("react");
const authApiClient_types_1 = require("root/src/server/util/awsClients/authApiClient.types");
const useCreatorDataActionButtons = () => {
    const dispatch = (0, useStore_1.useAppDispatch)();
    const user = (0, useUser_1.useUser)();
    const isAuthenticated = Boolean(user === null || user === void 0 ? void 0 : user.authentication);
    const creatorData = (0, useCreatorData_1.useCreatorData)();
    const isTransformableToCreator = (0, react_1.useMemo)(() => {
        var _a;
        const authentication = user === null || user === void 0 ? void 0 : user.authentication;
        if (!isAuthenticated) {
            return false;
        }
        const isCreator = (_a = authentication === null || authentication === void 0 ? void 0 : authentication.groups) === null || _a === void 0 ? void 0 : _a.includes(authApiClient_types_1.AuthGroup.Creator);
        if (isCreator) {
            return false;
        }
        return (creatorData === null || creatorData === void 0 ? void 0 : creatorData.userId) === (authentication === null || authentication === void 0 ? void 0 : authentication.userId);
    }, [user, creatorData]);
    const onFollow = () => {
        if (!creatorData)
            return;
        if (isAuthenticated) {
            dispatch((0, auditFollowCreator_1.default)());
            return;
        }
        dispatch((0, displayModal_1.default)(moduleIds_1.FOLLOW_CREATOR_MODAL_MODULE_ID, { username: creatorData.mnemonicId }));
    };
    return {
        isTransformableToCreator,
        onFollow,
    };
};
exports.useCreatorDataActionButtons = useCreatorDataActionButtons;
